import React from 'react';
import classes from "./MyTeam2.module.css";
import { useDispatch } from 'react-redux';
import { togglePlayerPointsModal } from '../../store/slices/playerPointsModalSlice';
import { useTranslation } from 'react-i18next';

const POSITION_LABELS = {
    attackers: "ST",
    midfielders: "MID",
    defenders: "DEF",
    goalkeeper: "GK",
};

const PlayerCard = ({ data, match_fixture_id, dispatch }) => (
    <div
        className={classes.grid_sub_container}
        onClick={() => dispatch(togglePlayerPointsModal({ playerId: data?.id, matchFixtureId: match_fixture_id }))}
    >
        <div className={classes.image_container}>
            <img src={data?.photo} alt={data?.name} className={classes.image} />

            {/* Points badge */}
            <div className={classes.square}>
                <p className={classes.point}>{data?.point ?? 0}</p>
            </div>

            {/* C / VC badge */}
            {data?.captain ? (
                <div className={classes.square2_captain}>
                    <p className={classes.indicate}>C</p>
                </div>
            ) : data?.viceCaptain ? (
                <div className={classes.square2_vc}>
                    <p className={classes.indicate}>VC</p>
                </div>
            ) : null}
        </div>

        <div className={classes.player_name}>
            <p>{data?.name}</p>
        </div>
    </div>
);

const PositionRow = ({ players, label, match_fixture_id, dispatch }) => {

    if (!players?.length) return null;
    return (
        <div className={classes.position_row}>
            <div
                className={classes.grid_container}
                style={{ gridTemplateColumns: `repeat(${players.length}, 1fr)` }}
            >
                {players.map((data, i) => (
                    <PlayerCard
                        key={data?.id ?? i}
                        data={data}
                        match_fixture_id={match_fixture_id}
                        dispatch={dispatch}
                    />
                ))}
            </div>
        </div>
    );
};

const MyTeam2 = ({ attackers, midfielders, defenders, goalkeeper, match_fixture_id }) => {

    const { t } = useTranslation();
    const dispatch = useDispatch();

    return (
        <div className={classes.line_up_container}>
            <div className={classes.line_up_sub_container}>

                {/* Pitch background */}
                <img
                    src="/assets/images/football-ground-half.jpg"
                    alt="football ground"
                    className={classes.ground}
                />

                {/* Dark vignette overlay */}
                <div className={classes.vignette} />

                {/* Position rows: attackers → midfielders → defenders → goalkeeper */}
                <div className={classes.sub_container}>
                    <PositionRow players={attackers} label={POSITION_LABELS.attackers} match_fixture_id={match_fixture_id} dispatch={dispatch} />
                    <PositionRow players={midfielders} label={POSITION_LABELS.midfielders} match_fixture_id={match_fixture_id} dispatch={dispatch} />
                    <PositionRow players={defenders} label={POSITION_LABELS.defenders} match_fixture_id={match_fixture_id} dispatch={dispatch} />
                    <PositionRow players={goalkeeper} label={POSITION_LABELS.goalkeeper} match_fixture_id={match_fixture_id} dispatch={dispatch} />
                </div>
            </div>
        </div>
    );
};

export default MyTeam2;